/* 🤖 this file was generated by svg-to-ts */
export const IconBigBrandYoutube: {
    name: 'big-brand-youtube';
    data: string;
} = {
    name: 'big-brand-youtube',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M75.65 63 57.51 52.61c-.78-.44-1.51.12-1.51 1v20.3c0 .89.7 1.46 1.49 1l18-9.88a1.19 1.19 0 0 0 .16-2.03"/><path d="M110.28 7.72H17.72a10 10 0 0 0-10 10v92.56a10 10 0 0 0 10 10h92.56a10 10 0 0 0 10-10V17.72a10 10 0 0 0-10-10M104 74.58A17.42 17.42 0 0 1 86.58 92H41.42A17.42 17.42 0 0 1 24 74.58V53.42A17.42 17.42 0 0 1 41.42 36h45.16A17.42 17.42 0 0 1 104 53.42z"/></svg>`,
};
